import React from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './ProfitItem.module.scss';

const ProfitItem = props => (
  <div className={`${styles.ProfitContainer} ${props.className}`}>
    <div className={styles.ProfitIcon}>
      <img
        src={OptimizeImagesService.adjustImageSize(props.specialization.logo)}
        alt="icon"
      />
    </div>
    <h3 className={styles.Text}>{props.specialization.header}</h3>
  </div>
);

ProfitItem.propTypes = {
  specialization: PropTypes.object.isRequired
};

ProfitItem.defaultProps = {
  className: ''
};

export default ProfitItem;



// WEBPACK FOOTER //
// ./src/views/Strategy/components/ProfitItem/ProfitItem.js